export default __webpack_public_path__ + "static/media/03.c10c0959.svg";